export const sourceTypes = {
    PAGE: 'PAGE',
    TEMPLATE: 'TEMPLATE',
    FORM: 'FORM',
    EMAIL: 'EMAIL',
    INTERACTION: 'INTERACTION',
    MEETING: 'MEETING'

};
